import { Context, createContext } from 'react';
import { ModeEnum, RealmEnum } from '../model';

export interface IAccess {
  realm: RealmEnum;
  sport: string;
  tier: number;
}

export interface IAppSettingsContext {
  comparison: true | false;
  mode: ModeEnum;
  accesses?: IAccess[];
  showBackground?: boolean;
  type?: 'popover'
}

const defaultValue: IAppSettingsContext = {
  showBackground: true,
  comparison: true,
  mode: ModeEnum.Full
}

export const AppSettingsContext: Context<IAppSettingsContext> = createContext(defaultValue);
